import React from "react"

import { BuildingReferenceFilterFormData } from "entities/building-references/types/BuildingReferenceFilterFormData"
import { ProductSelectOption } from "entities/products/types/ProductSelectOption"

import { useBuildingReferenceFilterViewModel } from "./model/useBuildingReferenceFilterViewModel"
import { BuildingReferenceFilterView } from "./ui/BuildingReferenceFilterView"

export interface BuildingReferenceFilterModel {
  defaultValues: BuildingReferenceFilterFormData
  onChange: (formData: BuildingReferenceFilterFormData) => void

  productOptions: ProductSelectOption[]

  isLoading: boolean
}

export const BuildingReferenceFilter = React.memo(
  (model: BuildingReferenceFilterModel) => {
    return (
      <BuildingReferenceFilterView
        {...useBuildingReferenceFilterViewModel(model)}
      />
    )
  }
)

BuildingReferenceFilter.displayName = "BuildingReferenceFilter"
